export const getValidations = (validations) => {
  let validators = [];
  let errorMessages = [];

  validations.forEach((validation) => {
    validators = [...validators, validation.validator];
    errorMessages = [...errorMessages, validation.msg];
  });

  return {
    validators,
    errorMessages
  };
};